<div style="margin-bottom: 10px;">
  <mat-form-field class="full-width">
    <input matInput type="text" [placeholder]="'ORDER.MOBILE.FORM.MOBILE' | translate" [(ngModel)]="phoneNumber" [imask]="phoneMask"
      [unmask]="true" [disabled]="isSendingCode || confirmationCodeInputDisabled" minlength="10" maxlength="15" #phoneNumberForm="ngModel" required>
      <mat-error *ngIf="phoneNumberForm.invalid">
        {{'ORDER.FULL_NAME.FORM.REQUIRED_PHONE_FORMAT' | translate}}
      </mat-error>
  </mat-form-field>

  <br>

  <div style="color:red;" *ngIf="phoneInUseError">
    {{'ORDER.MOBILE.FORM.PHONE_IN_USE' | translate}}
  </div>
  <div style="color:red;" *ngIf="phoneError">
    {{'ORDER.MOBILE.FORM.PHONE_ERROR' | translate}}
  </div>
  <div *ngIf="!confirmationCodeInputDisabled">
    <small>
      {{"ORDER.MOBILE.NUMBER_FORMAT" | translate}}
    </small>
  </div>

  <br>

  <button mat-raised-button type="button" id="button-mobile-send-code" color="primary" *ngIf="!confirmationCodeInputDisabled" [disabled]="!phoneNumberForm.valid || ticks>0" (click)="sendCode()">
    {{"ORDER.MOBILE.SEND" | translate}}
    <span> {{getTick()}}</span>
  </button>
</div>

<div *ngIf="confirmationCodeInputDisabled">
  <mat-form-field class="full-width">
    <input matInput type="text" pattern="^[0-9]*$" [placeholder]="'ORDER.MOBILE.FORM.CONFIRMATION_CODE' | translate" [(ngModel)]="confirmationCode"
      #confirmationCodeForm="ngModel" [disabled]="!confirmationCodeInputDisabled" minlength="4" required>
  </mat-form-field>

  <button mat-raised-button type="button" color="primary" [disabled]="!confirmationCodeForm.valid || _phoneVerified" (click)="tryCode()">
    {{ (_phoneVerified ? "ORDER.MOBILE.CONFIRMED": "ORDER.MOBILE.CONFIRM") | translate}}
  </button>&nbsp;
  <button mat-raised-button type="button" color="secondary" [disabled]="_phoneVerified" (click)="changeNumber()">
    {{ (_phoneVerified ? "ORDER.MOBILE.CONFIRMED": "ORDER.MOBILE.CHANGE") | translate}}
  </button>
</div>
